// DrimifyWidget.jsx
import { useEffect, useRef } from "react";
import './DrimifyWidget.scss';
import { apiVoissa } from "../api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePostHog } from 'posthog-js/react';

export default function DrimifyWidget({ url, onClose, onComplete }) {
  const containerRef = useRef(null);
  const DigitaService = window.DigitaService;
  const queryClient = useQueryClient();
  const posthog = usePostHog();
  
  const {mutate} = useMutation((data) => {
    return apiVoissa.post('/game-service/register-loot', data);
  }, {
    onSuccess: (data) => {
      // if(!data.hasWon) setCanClose(true);
      queryClient.invalidateQueries(['game-service-show']);
      posthog.capture('drimify_game_complete', data);
      if(typeof onComplete === 'function'){
        onComplete(data);
      }
    },
    onError: (error) => {
      console.error('Error registering game:', error);
    }
  });

  if (!DigitaService) {
    throw new Error("Drimify widget script not loaded");
  }

  const _onComplete = async (data) => {
    // setCanClose(false);
    mutate(data);
  }

  const createWidget = () => {
    if (!DigitaService || !containerRef.current) return;

      const widget = DigitaService.Widget.Create({
        autoscroll: true,
        element: containerRef.current.id,
        engine: url,
        fixed: false,
        height: ["auto"],
        sharingurl: url,
        width: "100%"
      });

      widget.onComplete = _onComplete;
      widget.load();
    };

  useEffect(() => {
    createWidget();
    return () => {
      DigitaService.Widget.Destroy();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return (
    <div className="drimify-modal-overlay">
        <div className="drimify-modal-content" onClick={(e) => e.stopPropagation()}>
            {/* <button className="drimify-close-btn">×</button> */}
            <div id="gamification-widget" ref={containerRef}></div>
        </div>
    </div>
  );
}
